import * as angular from 'angular';

/*@ngInject*/
export default['$parse', ($parse) => {

    let DISABLED = 'disabled',
        CLICK_EVENT = 'click',
        CLICK_ATTR = 'ngClick',
        SUBMIT_EVENT = 'submit',
        SUBMIT_ATTR = 'ngSubmit',
        LOADING_CLASS_ATTR = 'ngAutodisableClass';

    let isPromise = promise => promise &&
        angular.isFunction(promise.then) &&
        angular.isFunction(promise['finally']);


    let triggerHandler = (handler, scope, event, fn) => {
        let result = fn(scope, {$event: event});
        if (isPromise(result)) handler.handlePromise(result);
    };

    let linkFn = (scope, element, attrs) => {
        let handler;
        if (attrs.hasOwnProperty(CLICK_ATTR)) {
            handler = handlerInstance(element,
                CLICK_EVENT,
                getLoadingClass(attrs),
                getCallbacks(attrs[CLICK_ATTR]));
        } else if (attrs.hasOwnProperty(SUBMIT_ATTR)) {
            handler = handlerInstance($("button[type=submit]", element),
                SUBMIT_EVENT,
                getLoadingClass(attrs),
                getCallbacks(attrs[SUBMIT_ATTR]));
        } else {
            throw new Error('ngAutodisable requires ngClick or ngSubmit attribute in order to work');
        }

        element.unbind(handler.eventName).bind(handler.eventName, function (event) {
            scope.$apply(function () {
                handler.callbacks.forEach(triggerHandler.bind(null, handler, scope, event));
            });
        });
    };

    let getCallbacks = (expression) =>
        expression.split(';').map((callback) =>
            $parse(callback, null, true)
        );


    let getLoadingClass = (attrs) =>
        attrs.hasOwnProperty(LOADING_CLASS_ATTR) ? attrs[LOADING_CLASS_ATTR] : false;

    let handlerInstance = (elementToDisable, eventName, loadingClass, callbacks) => {
        let instance: any = {},
            promisesTriggered = 0;

        instance.eventName = eventName;
        instance.callbacks = callbacks;

        instance.handlePromise = (promise) => {
            if (promisesTriggered === 0) {
                disableElement();
            }
            promisesTriggered++;

            promise['finally'](() => {
                promiseDone();
            });
        };

        let promiseDone = () => {
            promisesTriggered--;
            if (promisesTriggered === 0) enableElement();
        };

        let disableElement = () => {
            elementToDisable.attr(DISABLED, true);
            if (loadingClass) elementToDisable.addClass(loadingClass);
        };

        let enableElement = () => {
            elementToDisable.attr(DISABLED, false);
            if (loadingClass) elementToDisable.removeClass(loadingClass);
        };

        return instance;
    };

    return {
        restrict: 'A',
        link: linkFn
    };
}]
